module.exports = __webpack_public_path__ + "static/media/bg_netizenplledge_01.0253ba99.jpg";